/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAssistantSessionSummarySecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetAssistantSessionSummaryRequest = {
  /**
   * The assistant whose activity to summarize
   */
  assistantId: string;
  /**
   * Start of the activity range (ISO 8601)
   */
  from: Date;
  /**
   * End of the activity range (ISO 8601)
   */
  to: Date;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetAssistantSessionSummarySecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAssistantSessionSummarySecurity$outboundSchema: z.ZodMiniType<
  GetAssistantSessionSummarySecurity$Outbound,
  GetAssistantSessionSummarySecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getAssistantSessionSummarySecurityToJSON(
  getAssistantSessionSummarySecurity: GetAssistantSessionSummarySecurity,
): string {
  return JSON.stringify(
    GetAssistantSessionSummarySecurity$outboundSchema.parse(
      getAssistantSessionSummarySecurity,
    ),
  );
}

/** @internal */
export type GetAssistantSessionSummaryRequest$Outbound = {
  assistant_id: string;
  from: string;
  to: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetAssistantSessionSummaryRequest$outboundSchema: z.ZodMiniType<
  GetAssistantSessionSummaryRequest$Outbound,
  GetAssistantSessionSummaryRequest
> = z.pipe(
  z.object({
    assistantId: z.string(),
    from: z.pipe(z.date(), z.transform(v => v.toISOString())),
    to: z.pipe(z.date(), z.transform(v => v.toISOString())),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      assistantId: "assistant_id",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getAssistantSessionSummaryRequestToJSON(
  getAssistantSessionSummaryRequest: GetAssistantSessionSummaryRequest,
): string {
  return JSON.stringify(
    GetAssistantSessionSummaryRequest$outboundSchema.parse(
      getAssistantSessionSummaryRequest,
    ),
  );
}
